import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
	static targets = ["price"]
	static values = { 
		min: Number,
		max: Number,
    sessionsRemaining: Number
	}

  connect() {
    this.validate()
  }

	validate() {
    if (this.priceTarget.value < this.minValue) {
      this.priceTarget.value = this.minValue;
    } else if (this.priceTarget.value > this.maxValue) {
      this.priceTarget.value = this.maxValue;
    }
    const registerAsAttendee = document.getElementById('register-as-attendee');
    const registerByPurchase = document.getElementById('register-by-purchase');
    if(registerAsAttendee && registerByPurchase){
      document.getElementById('register-as-attendee').classList.add('d-none');
      document.getElementById('register-by-purchase').classList.add('d-none');
      console.log('this.sessionsRemainingValue',this.sessionsRemainingValue);
      if(this.sessionsRemainingValue > 0){
        if(this.sessionsRemainingValue >= this.priceTarget.value){
          document.getElementById('register-as-attendee').classList.remove('d-none');
        }else if(this.priceTarget.value > this.sessionsRemainingValue){
          document.getElementById('register-by-purchase').classList.remove('d-none');
        }
      } else {
        document.getElementById('register-by-purchase').classList.remove('d-none');
      }
    }

		const authorizeNetForm = document.getElementById("authnet-checkout-form")
		if (!!authorizeNetForm) {
			const selectedPriceInput = document.getElementById("selected_price")
			selectedPriceInput.setAttribute("value", this.priceTarget.value)
		}

		const paypalLink = document.getElementById("paypal-onetime-payment")
    this.setPrice(paypalLink)

    const registerlLink = document.getElementById("session_register")
    this.setPrice(registerlLink)
	}

  setPrice(linkEl) {
    if (linkEl) {
      const priceIndex = linkEl.href.indexOf("&price=")

      console.log('this.priceTarget.value = '+ this.priceTarget.value)

      if (priceIndex > 0) {
        linkEl.href = linkEl.href.substring(0, priceIndex) + '&price=' + this.priceTarget.value
      } else {
        linkEl.href = linkEl.href + '&price=' + this.priceTarget.value 
      }
    }
  }
}
